
import { InputNumber as AntInputNumber, InputNumberProps } from "@basic-components";
export const InputPrecisionNumber = ({ label = '', isView, value, ...rest }: { label: string; isView?: boolean } & InputNumberProps) => {
  if (isView) return value !== undefined && value !== null && value !== '' ? value : '--';
  const { onChange, ...restProps } = rest as any;
  const handleChange = (value: any) => {
    let nextValue = value;
    if (typeof value === "string" && !Number.isNaN(Number(value))) {
      nextValue = Number(value);
    }
    onChange?.(nextValue);
  };
  return (
    <AntInputNumber
      value={value}
      placeholder={`请输入${label}`}
      {...restProps}
      onChange={handleChange}
      step={1}
      min={0}
      style={{ width: "100%" }}
    />
  );
};
